import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Variant = 'default' | 'accent' | 'success' | 'warning' | 'danger' | 'outline';

const variants: Record<Variant, string> = {
  default: 'bg-bg-inset text-fg border-fg/85 dark:border-fg/40',
  accent: 'bg-amber-300 text-fg border-fg/85 dark:bg-amber-400/30 dark:border-fg/40',
  success: 'bg-success/15 text-success border-success/60',
  warning: 'bg-warning/20 text-fg border-fg/85 dark:border-fg/40',
  danger: 'bg-danger/15 text-danger border-danger/60',
  outline: 'bg-surface text-fg border-fg/85 dark:border-fg/40',
};

export function Badge({
  children,
  variant = 'default',
  className,
}: {
  children: ReactNode;
  variant?: Variant;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 text-2xs font-bold uppercase tracking-wide rounded-md border-[1.5px]',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
